import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import ProjectService from '../../services/ProjectService'
import { useProject } from '../../context/ProjectContext'
import { useAllProjects } from '../../context/AllProjectsContext'

const DeleteProjectsConfirmationModal = ({
  deleteOpen,
  setDeleteOpen,
  projectsToggler,
  setProjectsToggler,
  projectsToDelete,
  setCheckedProjects
}) => {
  const { selectedProject, setSelectedProject } = useProject()
  const { refreshProjects } = useAllProjects()
  const [loading, setLoading] = useState(false)

  const handleCloseDeleteDialog = () => {
    setDeleteOpen(false)
  }

  const handleDeleteProjects = async () => {
    setLoading(true)
    try {
      await ProjectService.deleteProjects(projectsToDelete)
      await refreshProjects()
      setCheckedProjects([])
      if (projectsToDelete.find(project => project === selectedProject?.id)) {
        const firstProject = await ProjectService.getAllProjects(1, 1)
        setSelectedProject(firstProject.projects[0])
      }
      setProjectsToggler(!projectsToggler)
      setDeleteOpen(false)
    } catch (error) {
      console.log(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={deleteOpen}
      onClose={handleCloseDeleteDialog}
    >
      <Box className="deleteProjectModal">
        <DialogTitle className="deleteProjectModalTitle">
          Confirm Delete Project
          {projectsToDelete.length > 1 && "s"}
        </DialogTitle>
        <DialogContent className="deleteProjectModalContent">
          <DialogContentText className="deleteProjectModalContentText">
            Are you sure you want to delete {projectsToDelete.length > 1 ? "these" : "this"} project{projectsToDelete.length > 1 && "s"}? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions className="deleteProjectModalActions">
          <Button className="deleteProjectModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deleteProjectModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deleteProjectModalButton" onClick={handleDeleteProjects} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeleteProjectsConfirmationModal